import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/navbar/miniprog.png'
import _imports_1 from '@/assets/img/navbar/miniprog-active.png'
import _imports_2 from '@/assets/img/navbar/notice.png'
import _imports_3 from '@/assets/img/navbar/notice-active.png'


const _withScopeId = n => (_pushScopeId("data-v-e8d780ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-sort check-icon" }, null, -1))
const _hoisted_3 = { class: "right" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "miniprog-guide" }, "少量的加减保使用手机更方便~", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "miniprog hover" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon icon-active",
    src: _imports_1
  }),
  /*#__PURE__*/_createElementVNode("span", null, "小程序版")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "line" }, null, -1))
const _hoisted_8 = { class: "notice-list" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notice-top" }, "未读消息", -1))
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "dot dot-red"
}
const _hoisted_12 = { class: "notice-detail" }
const _hoisted_13 = { class: "notice-head row" }
const _hoisted_14 = { class: "notice-title" }
const _hoisted_15 = { class: "notice-date grey" }
const _hoisted_16 = { class: "notice-content" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_2
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon-active",
  src: _imports_3
}, null, -1))
const _hoisted_19 = {
  key: 0,
  class: "unNum"
}
const _hoisted_20 = { class: "el-dropdown-link container-user" }
const _hoisted_21 = { class: "user-name" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "triangle" }, null, -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 账号设置 ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("退出登录 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_switch_client = _resolveComponent("switch-client")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "container-title",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.switchClient && _ctx.switchClient(...args)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.companyName), 1),
        _hoisted_2
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.qrcode)
          ? (_openBlock(), _createBlock(_component_el_popover, {
              key: 0,
              placement: "bottom",
              width: 200,
              trigger: "hover"
            }, {
              reference: _withCtx(() => [
                _hoisted_6
              ]),
              default: _withCtx(() => [
                _createElementVNode("img", {
                  style: {"width":"100%","height":"100%"},
                  src: _ctx.qrcode
                }, null, 8, _hoisted_4),
                _hoisted_5
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _hoisted_7,
        _createVNode(_component_el_popover, {
          onShow: _ctx.getMessage,
          placement: "bottom",
          width: 320,
          trigger: "hover"
        }, {
          reference: _withCtx(() => [
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ path: '/message' }))),
              class: "notice hover"
            }, [
              _hoisted_17,
              _hoisted_18,
              (_ctx.unReadNum)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.unReadNum), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "notice-item",
                  key: index
                }, [
                  _createElementVNode("img", {
                    class: "notice-icon",
                    src: item.icon
                  }, null, 8, _hoisted_10),
                  (!item.status)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(item.title), 1),
                      _createElementVNode("div", _hoisted_15, _toDisplayString(item.create_time), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, _toDisplayString(item.content), 1)
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", {
                class: "notice-bottom link",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ path: '/message' })))
              }, " 更多信息 ")
            ])
          ]),
          _: 1
        }, 8, ["onShow"]),
        _createVNode(_component_el_dropdown, { class: "" }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ path:'/user/setting'})))
                }, {
                  default: _withCtx(() => [
                    _hoisted_24
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, { onClick: _ctx.exit }, {
                  default: _withCtx(() => [
                    _hoisted_25
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$store.state.userName), 1),
              _createElementVNode("img", {
                class: "user-avatar",
                src: _ctx.$store.state.avatar
              }, null, 8, _hoisted_22),
              _hoisted_23
            ])
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.isSwitchClientAlert)
      ? (_openBlock(), _createBlock(_component_switch_client, {
          key: 0,
          clientName: _ctx.companyName,
          onClose: _ctx.switchClient
        }, null, 8, ["clientName", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}